<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="18.155" height="33.715" viewBox="0 0 18.155 33.715">
    <path fill="none" stroke="currentColor" stroke-width="2.5px" d="M15.516,31.974,0,15.987,15.516,0" transform="translate(1.742 0.871)"/>
  </svg>
</template>
